import React from 'react';
import web from '../assets/images/web.jpeg';

const Work = () => (
  <div className="work-main-container" id="work" name="work">
    <div className="left-area-container" data-aos="fade-right">
      <div className="mobile-website">
        <div className="work-item">
          <div className="icon-wrapper">
            <svg
              className="mobile-icon"
              viewBox="0 0 292 576"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M291.98 129.76V195.44C291.978 196.047 291.737 196.628 291.307 197.057C290.878 197.487 290.297 197.728 289.69 197.73H288.06V539.88C288.06 549.348 284.298 558.428 277.603 565.123C270.908 571.818 261.828 575.579 252.36 575.58H38.5701C33.8825 575.58 29.2408 574.656 24.9103 572.861C20.5797 571.067 16.645 568.437 13.3309 565.122C10.0167 561.807 7.38796 557.872 5.59479 553.54C3.80162 549.209 2.87915 544.568 2.88001 539.88V209.73H1.69995C1.27183 209.731 0.860916 209.562 0.557255 209.26C0.253593 208.958 0.0819575 208.548 0.0799598 208.12V170.74C0.0799138 170.527 0.121794 170.317 0.20319 170.12C0.284585 169.923 0.403886 169.745 0.554325 169.594C0.704764 169.444 0.883391 169.325 1.07996 169.243C1.27653 169.162 1.4872 169.12 1.69995 169.12H2.88001V155.04H1.68995C1.24053 155.038 0.810191 154.858 0.493351 154.54C0.176511 154.221 -0.00093476 153.789 3.70359e-06 153.34V116.47C0.00114411 116.022 0.179543 115.593 0.49622 115.276C0.812896 114.96 1.24209 114.781 1.68995 114.78H2.88001V95.56H1.66993C1.47287 95.5603 1.27769 95.5216 1.09558 95.4464C0.913478 95.3711 0.748048 95.2606 0.608707 95.1212C0.469367 94.9819 0.358862 94.8164 0.283573 94.6343C0.208284 94.4522 0.169662 94.2571 0.169926 94.06V73.94C0.169021 73.541 0.326456 73.1579 0.60767 72.8748C0.888883 72.5917 1.27091 72.4317 1.66993 72.43H2.88001V31.69C2.88037 22.2245 6.6407 13.1468 13.3338 6.45374C20.0269 -0.239362 29.1046 -3.99966 38.5701 -4H252.36C261.827 -4.00004 270.905 -0.240195 277.6 6.4527C284.295 13.1456 288.057 22.2235 288.06 31.69V127.47H289.69C290.297 127.472 290.878 127.713 291.307 128.142C291.737 128.572 291.978 129.153 291.98 129.76V129.76Z"
                fill="#DBA858"
              />
              <path
                d="M155.765 14.3068H121.026C119.622 14.3068 118.484 15.4448 118.484 16.8487V19.8513C118.484 21.2551 119.622 22.3932 121.026 22.3932H155.765C157.169 22.3932 158.307 21.2551 158.307 19.8513V16.8487C158.307 15.4448 157.169 14.3068 155.765 14.3068Z"
                fill="#E6E8EC"
              />
              <path
                d="M168.915 22.9366C171.448 22.9366 173.502 20.8831 173.502 18.35C173.502 15.8168 171.448 13.7633 168.915 13.7633C166.382 13.7633 164.328 15.8168 164.328 18.35C164.328 20.8831 166.382 22.9366 168.915 22.9366Z"
                fill="#E6E8EC"
              />
              <path
                d="M270.965 38.7498V542.84C270.962 548.845 268.575 554.604 264.327 558.849C260.08 563.095 254.321 565.48 248.315 565.48H43.6651C40.6901 565.485 37.7433 564.903 34.9935 563.767C32.2438 562.631 29.7453 560.964 27.6411 558.861C25.537 556.758 23.8686 554.26 22.7316 551.511C21.5946 548.761 21.0113 545.815 21.0152 542.84V38.7498C21.015 35.7754 21.6008 32.83 22.739 30.0819C23.8773 27.3338 25.5456 24.8369 27.6489 22.7336C29.7522 20.6303 32.2491 18.962 34.9972 17.8237C37.7453 16.6855 40.6906 16.0997 43.6651 16.0999H74.2951V20.0298C74.2952 24.9761 76.2601 29.7198 79.7576 33.2173C83.2552 36.7149 87.9989 38.6798 92.9452 38.6799H197.025C201.971 38.6798 206.715 36.7149 210.213 33.2174C213.71 29.7198 215.675 24.9761 215.675 20.0298V16.0999H248.315C251.29 16.0989 254.236 16.6841 256.984 17.822C259.732 18.96 262.23 20.6283 264.333 22.7317C266.437 24.8352 268.105 27.3325 269.243 30.0809C270.381 32.8294 270.966 35.7751 270.965 38.7498V38.7498Z"
                fill="#0E1630"
              />
              <path
                d="M250.407 347.959H42.4071V374.959H250.407V347.959Z"
                fill="#E6E6E6"
              />
              <path
                d="M250.407 395.959H42.4071V422.959H250.407V395.959Z"
                fill="#E6E6E6"
              />
              <path
                d="M250.407 443.959H42.4071V470.959H250.407V443.959Z"
                fill="#E6E6E6"
              />
              <path
                d="M227.407 106.959C238.453 106.959 247.407 98.0046 247.407 86.9589C247.407 75.9132 238.453 66.9589 227.407 66.9589C216.361 66.9589 207.407 75.9132 207.407 86.9589C207.407 98.0046 216.361 106.959 227.407 106.959Z"
                fill="#DBA858"
              />
              <path
                d="M249.99 153.959H41.99V291.959H249.99V153.959Z"
                fill="#E6E6E6"
              />
              <path
                d="M124.816 231.55C130.889 254 151.691 267.904 151.691 267.904C151.691 267.904 162.646 245.409 156.573 222.959C150.5 200.509 129.698 186.605 129.698 186.605C129.698 186.605 118.743 209.1 124.816 231.55Z"
                fill="#3F3D56"
              />
              <path
                d="M133.74 226.725C150.405 242.948 152.44 267.885 152.44 267.885C152.44 267.885 127.457 266.521 110.792 250.299C94.1269 234.076 92.0914 209.138 92.0914 209.138C92.0914 209.138 117.075 210.502 133.74 226.725Z"
                fill="#DBA858"
              />
              <path
                d="M180.065 231.55C173.991 254 153.189 267.904 153.189 267.904C153.189 267.904 142.234 245.409 148.307 222.959C154.38 200.509 175.182 186.605 175.182 186.605C175.182 186.605 186.138 209.1 180.065 231.55Z"
                fill="#3F3D56"
              />
              <path
                d="M171.141 226.725C154.476 242.948 152.44 267.885 152.44 267.885C152.44 267.885 177.424 266.521 194.089 250.299C210.753 234.076 212.789 209.138 212.789 209.138C212.789 209.138 187.805 210.502 171.141 226.725Z"
                fill="#DBA858"
              />
            </svg>
          </div>
          <div className="project-text">Mobile Development</div>
        </div>
        <div className="work-item">
          <div className="icon-wrapper">
            <img className="web-img" src={web} alt="web" />
          </div>
          <div className="project-text">Frontend Develpment</div>
        </div>
      </div>
      <div className="web-app-wrapper">
        <div className="work-item backend">
          <div className="icon-wrapper">
            <img className="web-img" src={web} alt="web" />
          </div>
          <div className="project-text">Backend Develpment</div>
        </div>
      </div>
    </div>
    <div className="right-area-container">
      <div className="title-container" data-aos="fade-up">
        <div className="before-line" />
        <h3 className="titles">What I do</h3>
      </div>
      <h2 className="slogan" data-aos="fade-up">
        Better Design,
        <br />
        {' '}
        Better experiences
      </h2>

      <p className="about-work" data-aos="fade-up">
        I&#39;m Building scalable web applications, Mobile apps and beautiful
        websites for companies.
      </p>
    </div>
  </div>
);

export default Work;
